import React, { useEffect, useState } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";
import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";
import Popup01 from "../../pages/popup/Popup01";
import { ToastContainer, toast, Slide } from 'react-toastify';
import { BrowserView, MobileView, isBrowser } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HEADER_TEXT = {
  title: {
    ko: '모든 직군을 위한 3D 모델링 툴',
    en: 'A 3D Tool for Any Role'
  },
  subTitle: {
    ko: '3D 모델링을 몰라도 쉽게 사용할 수 있습니다!',
    en: 'Easy to use, even if you\'re new to 3D modeling!'
  },
  startButton: {
    ko: '무료로 써보기',
    en: 'Try for free'
  },
  inquiryButton: {
    ko: '문의하기',
    en: 'Contact Us'
  }
};

const CONTENT_ITEMS = [
  {
    title: { ko: '레벨 디자이너', en: 'Level Designer' },
    bigTitle: { ko: '레벨 디자인과 비주얼을 모두 잡다', en: 'Design Levels with Visuals' },
    body: {
      ko: '색상, 형태, 분위기, 그리고 라이팅을 종합적으로 고려한 레벨 디자인은 단순한 도형만으로는 완성도가 부족할 수 있습니다. 이러한 요소들을 조화롭게 구성하여 최종 렌더링에 가까운 디자인을 구현하면, 초기 단계에서 잠재적인 문제를 미리 발견하고 수정할 수 있어 더욱 완성도 높은 결과물을 얻을 수 있습니다.',
      en: 'Great level design is more than just blockouts—it’s about atmosphere,  mood, and storytelling. You can seamlessly integrate colors, lighting,  and shapes from the start, creating near-final designs early on.  Identify issues sooner, refine details, and build immersive worlds with confidence.'
    },
    image: require("../../assets/gm_01.webp"),
    reverse: false
  },
  {
    title: { ko: '프로그래머', en: 'Programmer' },
    bigTitle: { ko: '실제 환경에서 시뮬레이션', en: 'Build, Test, Iterate—All Within Unity' },
    body: {
      ko: '완성된 기획이나 3D 데이터를 기다릴 필요 없이, Unity에서 바로 3D 공간을 빠르게 생성하여 즉시 코드 테스트를 진행할 수 있습니다. 이를 통해   개발 과정에서 반복적인 수정과 최적화를 더욱 효율적으로 수행할 수 있으며, 전체적인 작업 시간을 절약하면서도 높은 생산성을 유지할 수 있습니다.',
      en: 'Stop waiting for assets or pre-built environments. you can instantly  create 3D spaces inside Unity and test your code in real time.  Quickly refine gameplay, debug efficiently,  and optimize mechanics—all without leaving the engine.'
    },
    image: require("../../assets/gm_02.webp"),
    reverse: true
  },
  {
    title: { ko: 'VFX 아티스트', en: 'VFX Artist' },
    bigTitle: { ko: '연출에 필요한 리소스를 바로바로', en: 'Quickly Create the Assets You Need' },
    body: {
      ko: '실험적인 연출과 효과를 제작할 때, UModeler를 활용하여 3D 리소스를 실시간으로 수정하며 화면의 변화를 즉시 확인할 수 있습니다. 이를 통해 예측에 소요되는 시간을 줄이고, 직접 결과를 보며 세밀하게 조정할 수 있어 더욱 정밀하고 효율적인 작업이 가능합니다.',
      en: 'When crafting visual effects, use UModeler to edit 3D assets  in real time and see immediate changes on screen.  This reduces iteration time, allowing you to fine-tune effects  with precision and work more efficiently.'
    },
    image: require("../../assets/gm_03.webp"),
    reverse: false
  },
  {
    title: { ko: '기획자', en: 'Game Designer' },
    bigTitle: { ko: '3D 그래픽을 이해하고 직접 구현하는 기획', en: 'Bring Your Ideas to Life in 3D' },
    body: {
      ko: '3D 콘텐츠 제작을 위해서는 3D 그래픽에 대한 기본적인 이해가 필수입니다. 그러나 복잡한 이론을 따로 학습하는 대신, 익숙한 Unity 엔진 내에서 직접 실습하며 배울 수 있어 기획을 직접 구현하기 효과적입니다. 또한, 팀원들과의 협업 시에도 기획자가 효과적인 가이드를 제공할 수 있어 작업의 효율성과 생산성이 더욱 향상됩니다.',
      en: 'Quickly build 3D prototypes in Unity—no extra tools needed.  Craft immersive environments, refine your vision, and provide clear  guidance for your team—enhancing both workflow and productivity.'
    },
    image: require("../../assets/gm_04.webp"),
    reverse: true
  },
  {
    title: { ko: '테크니컬 아티스트', en: 'Technical Artist' },
    bigTitle: { ko: '리소스 테스트와 빠른 커뮤니케이션', en: 'Instant Test, Clear Communication' },
    body: {
      ko: '빠른 의사소통과 신속한 테스트는 문제 해결의 핵심 요소입니다. 테크니컬 아티스트라면 UModeler를 활용하여 직접 3D 리소스를 테스트하고, 즉각적인 피드백을 제공할 수 있습니다. 이를 통해 개발 과정에서 발생하는 문제를 빠르게 파악하고 해결할 수 있으며, 팀원들에게 보다 명확한 시각적 가이드를 제시하여 협업의 효율성을 극대화할 수 있습니다.',
      en: 'For technical artists, fast iteration and clear feedback are key to solving  problems efficiently. Test 3D assets directly, catch issues early,  and give instant visual feedback. Enhance collaboration  with clear visuals for a smoother, more efficient workflow.'
    },
    image: require("../../assets/gm_05.webp"),
    reverse: false
  },
  {
    title: { ko: '인디/하이퍼 캐주얼 개발자', en: 'Indie/Hyper-Casual Developer' },
    bigTitle: { ko: '하나의 도구로 완성하는 고품질 게임 개발', en: 'One Tool for High-Quality Game' },
    body: {
      ko: '하나의 도구로 더욱 효율적으로 게임을 제작해 보세요! Unity에서 3D 모델링, 리깅, 그리고 페인팅까지 모두 해결할 수 있어 별도의 외부 툴 없이도 완성도 높은 작업이 가능합니다. 이를 통해 소규모 팀에서도 높은 퀄리티의 게임을 제작할 수 있으며, 개발 과정의 복잡성을 줄이고 보다 빠르게 결과물을 구현할 수 있습니다.',
      en: 'Create games more efficiently with just one tool!  With Unity, you can handle 3D modeling, rigging, and painting—all  in one place. No need for extra software, ensuring a seamless workflow. Even small teams can achieve high-quality results  while simplifying development and accelerating production.'
    },
    image: require("../../assets/gm_06.webp"),
    reverse: true
  },
  {
    title: { ko: '3D 아티스트', en: '3D Artist' },
    bigTitle: { ko: '번거로운 임포트 없이 깔끔한 워크플로우', en: 'Seamless Workflow' },
    body: {
      ko: 'Maya, 3ds Max, Blender를 사용 중이라면 Unity 엔진 내 모델링 스킬을 익혀  커리어를 더욱 강화하세요. UModeler를 활용하면 엔진 뷰가 곧 최종 뷰가 되어  실시간으로 결과를 확인하며 효율적으로 작업할 수 있습니다.',
      en: 'Model in Unity, no import/export needed. If you\'re using Maya,  3ds Max, or Blender, UModeler lets you refine your skills and  create directly in the engine. Get instant feedback, see final  results in real-time, and work with maximum efficiency.'
    },
    image: require("../../assets/gm_07.webp"),
    reverse: false
  }
];

const PARTNER_TEXT = {
  title: {
    ko: '투자사 및 파트너',
    en: 'Investors and Partners'
  }
};

const BANNER_TEXT = {
  title: {
    ko: '유니티 게임 개발 팀워크를 위한 최고의 선택',
    en: 'Power Up Your Unity Game Development'
  },
  inquiryButton: {
    ko: '문의하기',
    en: 'Contact Us'
  },
  startButton: {
    ko: '무료로 써보기',
    en: 'Try for Free'
  }
};

export default function GameDev() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lang = useSelector(state => state.langReducer.lang);
  const [supBtnHover, setSupBtnHover] = useState(false);
  const partner_top_sample = 6;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="main_back">
        <div className="main_part padding">
          <div className="header_page_title_box">
            <p className="title">
              {lang === 0 ? HEADER_TEXT.title.ko : HEADER_TEXT.title.en}
            </p>
            <span className="sub_title">
              {lang === 0 ? HEADER_TEXT.subTitle.ko : HEADER_TEXT.subTitle.en}
            </span>
            <div className="btn_box">
              <button type="button" className={`start ${lang === 1 ? 'eng' : ''}`} style={{width: 280,}}
              onClick={() => {
                                    navigate(routes.Price);
                                }}>
                {lang === 0 ? HEADER_TEXT.startButton.ko : HEADER_TEXT.startButton.en}
              </button>
              <button type="button" className={`inquiry ${lang === 1 ? 'eng' : ''}`} style={{width: 280,}}
                onClick={() => navigate(routes.Inquiry)}>
                {lang === 0 ? HEADER_TEXT.inquiryButton.ko : HEADER_TEXT.inquiryButton.en}
              </button>
            </div>
          </div>
          <div className="header_page_content_box">
            {CONTENT_ITEMS.map((item, index) => {
              return (
                <div className={`content ${item.reverse ? 'end' : ''}`} key={index}>
                  {item.reverse ? (
                    <>
                      <div className="title_box">
                        <div className="top_title">
                          {lang === 0 ? item.title.ko : item.title.en}
                        </div>
                        <p>
                          {lang === 0 ? item.bigTitle.ko : item.bigTitle.en}
                        </p>
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {lang === 0 ? item.body.ko : item.body.en}
                        </span>
                      </div>
                      <div className="img_box_169" >
                        <img src={item.image} alt={`content-${index}`} />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="img_box_169" >
                        <img src={item.image} alt={`content-${index}`} />
                      </div>
                      <div className="title_box">
                        <div className="top_title">
                          {lang === 0 ? item.title.ko : item.title.en}
                        </div>
                        <p>
                          {lang === 0 ? item.bigTitle.ko : item.bigTitle.en}
                        </p>
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {lang === 0 ? item.body.ko : item.body.en}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className="page_start_banner">
          <div className="content">
            <p className="title">
              {lang === 0 ? BANNER_TEXT.title.ko : BANNER_TEXT.title.en}
            </p>
            <div className="btn_box">
              <button type="button" className={`start ${lang === 1 ? 'eng' : ''}`} style={{width: 220,}}
              onClick={() => {
                                    navigate(routes.Price);
                                }}>
                {lang === 0 ? BANNER_TEXT.startButton.ko : BANNER_TEXT.startButton.en}
              </button>
              <button type="button" className={`inquiry ${lang === 1 ? 'eng' : ''}`} style={{width: 220,}}
                onClick={() => navigate(routes.Inquiry)}>
                {lang === 0 ? BANNER_TEXT.inquiryButton.ko : BANNER_TEXT.inquiryButton.en}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        transition={Slide}
        limit={1}
        closeButton={false}
        autoClose={1000}
        style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
        hideProgressBar
      />
    </>
  );
}